export enum ServerErrorCode {
  // auth
  USER_ALREADY_ACTIVATED = 'USER_ALREADY_ACTIVATED',
  ACTIVATION_TOKEN_NOT_FOUND = 'ACTIVATION_TOKEN_NOT_FOUND',
  ACTIVATION_TOKEN_EXPIRED = 'ACTIVATION_TOKEN_EXPIRED',
  BAD_CREDENTIALS = 'BAD_CREDENTIALS',
  INVALID_GRANT = 'INVALID_GRANT',
  ACCOUNT_IS_LOCKED = 'ACCOUNT_IS_LOCKED',
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',

  // register
  INVITE_CODE_INVALID = 'INVITE_CODE_INVALID',

  // upload
  CANNOT_UPLOAD_FILE = 'CANNOT_UPLOAD_FILE',
  CANNOT_DOWNLOAD_FILE = 'CANNOT_DOWNLOAD_FILE',
  FILE_SIZE_LIMIT_EXCEEDED = 'FILE_SIZE_LIMIT_EXCEEDED',

  // download
  GENERATION_ZIP = 'GENERATION_ZIP',

  // user management
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_FROZEN = 'USER_ALREADY_FROZEN',
  DUPLICATE_USER_EMAIL = 'DUPLICATE_USER_EMAIL',
  ACCOUNT_OF_THIS_TYPE_CANNOT_BE_FROZEN = 'ACCOUNT_OF_THIS_TYPE_CANNOT_BE_FROZEN',
  MEDICAL_CASE_MODIFICATION_LOCKED = 'MEDICAL_CASE_MODIFICATION_LOCKED',
  INVALID_CASE_ASSIGNEE = 'INVALID_CASE_ASSIGNEE',
  NO_MEDICAL_CASE_DOCUMENTS_AVAILABLE_FOR_PROCESSING = 'NO_MEDICAL_CASE_DOCUMENTS_AVAILABLE_FOR_PROCESSING',
  EMPTY_COGNITO_ACCOUNT_ID = 'EMPTY_COGNITO_ACCOUNT_ID',
  USER_TYPE_NOT_CREATABLE = 'USER_TYPE_NOT_CREATABLE',
  SELF_MANAGED_ACCOUNT = 'SELF_MANAGED_ACCOUNT',
  CANNOT_MODIFY_OWN_ACCOUNT = 'CANNOT_MODIFY_OWN_ACCOUNT',
  USER_ALREADY_CONFIRMED = 'USER_ALREADY_CONFIRMED',
  UNSUPPORTED_LOCALE = 'UNSUPPORTED_LOCALE',

  // user password management
  USER_PASSWORD_RESET_TOKEN_NOT_FOUND = 'USER_PASSWORD_RESET_TOKEN_NOT_FOUND',
  INCORRECT_OLD_PASSWORD = 'INCORRECT_OLD_PASSWORD',
  NEW_PASSWORD_CANNOT_BE_THE_SAME_AS_OLD_PASSWORD = 'NEW_PASSWORD_CANNOT_BE_THE_SAME_AS_OLD_PASSWORD',
}
